module.exports = __webpack_public_path__ + "media/images/lb/893-d3236a901ed31ac9098953f0a4db1a1b.svg";